module.exports = __webpack_public_path__ + "img/arcade.cd01c815.webp";